[
  {
    "id": "TG-M7-L203-001",
    "module": "TijdGeld",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Hoeveel uur zit er tussen dinsdag 14:00 en woensdag 16:00?",
    "options": ["26 uur", "24 uur", "2 uur", "28 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "tijdsduur",
    "familyId": "TG-TIJD-DUUR-DAGEN_UREN",
    "conceptId": "elapsed_time_across_days_hours",
    "variantIndex": 1,
    "explanation": "Dinsdag 14:00 → woensdag 14:00 is precies 24 uur (1 etmaal).\nDaarna is het nog 2 uur tot 16:00.\n24 + 2 = 26 uur.",
    "distractorExplanations": {
      "1": "24 uur is alleen tot woensdag 14:00. Je mist nog het stuk van 14:00 naar 16:00 (2 uur extra).",
      "2": "2 uur is alleen het verschil tussen 14:00 en 16:00 op dezelfde dag. Je vergeet dat er een hele nacht/dag (24 uur) tussen zit.",
      "3": "28 uur zou kloppen als het 4 uur extra was na 24 uur (bijvoorbeeld tot 18:00). Maar het is tot 16:00, dus maar 2 uur extra."
    }
  },
  {
    "id": "TG-M7-L203-002",
    "module": "TijdGeld",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Je verdient € 4,80 per uur. Je werkt 7,5 uur. Hoeveel verdien je?",
    "options": ["€ 36,00", "€ 34,80", "€ 40,00", "€ 32,40"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "loon",
    "familyId": "TG-GELD-LOON-UURTARIEF",
    "conceptId": "hourly_wage_times_decimal_hours",
    "variantIndex": 1,
    "explanation": "7,5 uur is 7 uur en een half uur.\n7 uur: 7 × € 4,80 = € 33,60.\n0,5 uur is de helft van € 4,80 = € 2,40.\nSamen: € 33,60 + € 2,40 = € 36,00.",
    "distractorExplanations": {
      "1": "Je hebt waarschijnlijk alleen 7 uur gerekend (7 × 4,80 = 33,60) en daarna iets afgerond. Maar er komt nog een half uur bij: + € 2,40.",
      "2": "Dit is een ‘snelle schatting’ alsof het € 5 per uur is en/of alsof het 8 uur is. Maar je moet precies rekenen met € 4,80 en 7,5 uur.",
      "3": "Je hebt 4,80 × 7 gedaan en daarna per ongeluk 0,5 uur als 0,5 euro behandeld. 0,5 uur betekent: de helft van het uurtarief erbij (dus + € 2,40)."
    }
  },
  {
    "id": "TG-M7-L203-003",
    "module": "TijdGeld",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Hoeveel minuten is 1,75 uur?",
    "options": ["105 minuten", "175 minuten", "100 minuten", "75 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "omrekenen",
    "familyId": "TG-TIJD-OMREKENEN-UUR-DECIMAAL",
    "conceptId": "convert_decimal_hours_to_minutes",
    "variantIndex": 1,
    "explanation": "1,75 uur = 1 uur + 0,75 uur.\n1 uur = 60 minuten.\n0,75 uur is 3/4 uur. 3/4 van 60 = 45 minuten.\n60 + 45 = 105 minuten.",
    "distractorExplanations": {
      "1": "Je hebt de komma behandeld alsof je minuten ‘achter de komma’ direct kunt lezen. Maar 1,75 uur is geen 1 uur 75 minuten; je moet het deel achter de komma omrekenen naar minuten.",
      "2": "100 minuten kan een schatting zijn, maar 0,75 uur is exact 45 minuten. Dus 60 + 45 = 105, niet 100.",
      "3": "75 minuten is 1,25 uur (1 uur en 15 min). Maar hier gaat het om 1,75 uur (1 uur en 45 min)."
    }
  },
  {
    "id": "TG-M7-L203-004",
    "module": "TijdGeld",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Een abonnement kost € 14,50 per maand. Hoeveel kost dat per jaar?",
    "options": ["€ 174,00", "€ 145,00", "€ 160,00", "€ 180,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "abonnementen",
    "familyId": "TG-GELD-ABONNEMENT-NAAR-JAAR",
    "conceptId": "monthly_cost_to_yearly_total_decimal",
    "variantIndex": 1,
    "explanation": "Per jaar betaal je 12 maanden.\n12 × € 14,50 = (10 × 14,50) + (2 × 14,50).\n10 × 14,50 = € 145,00.\n2 × 14,50 = € 29,00.\nSamen: € 145,00 + € 29,00 = € 174,00.",
    "distractorExplanations": {
      "1": "€ 145,00 is wat je betaalt in 10 maanden (10 × € 14,50). Maar een jaar heeft 12 maanden: je mist nog 2 maanden (€ 29,00).",
      "2": "€ 160,00 is een te ruwe afronding (bijv. 12 × 13,33 of 12 × 14). Met € 14,50 per maand kom je exact uit op € 174,00.",
      "3": "€ 180,00 krijg je als je afrondt naar € 15 per maand (12 × 15). Maar € 14,50 is lager, dus de jaarprijs moet lager zijn dan € 180."
    }
  },
  {
    "id": "TG-M7-L203-005",
    "module": "TijdGeld",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Het is 20:35. De film duurt 125 minuten. Hoe laat is het afgelopen?",
    "options": ["22:40", "22:00", "22:35", "22:20"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "tijdsduur",
    "familyId": "TG-TIJD-DUUR-MINUTEN-OVERLOOP",
    "conceptId": "add_minutes_crossing_hour_boundary",
    "variantIndex": 1,
    "explanation": "125 minuten = 2 uur en 5 minuten.\n20:35 + 2 uur = 22:35.\n22:35 + 5 minuten = 22:40.\nDus de film is om 22:40 afgelopen.",
    "distractorExplanations": {
      "1": "22:00 past bij 85 minuten (1 uur 25 min) vanaf 20:35. Maar je moet 125 minuten optellen (2 uur 5 min).",
      "2": "22:35 is alleen 2 uur erbij. Je vergeet de extra 5 minuten uit de 125 minuten.",
      "3": "22:20 ontstaat vaak als je 125 minuten ziet als 1 uur 45 min (105 min) of als je verkeerd ‘omzet’. Maak er eerst 2 uur en 5 minuten van."
    }
  }
]
